import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
//import logger from 'redux-logger';

import { configReducer }  from '../reducers/index.js';
import { initSagas } from '../utilities/index.js';
// import { customizedMiddleware }  from '../utilities/customMiddleware';
import { getInitialState } from './defaultState.js';

const initialState = getInitialState();
const onError = error => console.log('Uncaught Global Saga Error:', error);
const sagaMiddleware = createSagaMiddleware(onError);
// const appLogger = logger();

export default function configureAppStore() {
  const store = configureStore({
    reducer: configReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(sagaMiddleware),
    devTools: process.env.NODE_ENV !== 'production',
    preloadedState: initialState,
  });

  initSagas(sagaMiddleware);
  console.info('saga is running');

  return store
}

